// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1AKMM","inputDescription":"styles_inputDescription__3Gxxg"};